export { default, default as FunctionalAvatar } from './FunctionalAvatar'
export * as FunctionalAvatarStyles from './styles/FunctionalAvatar.style'

export type { FunctionalAvatarProps, SizeKeys } from './FunctionalAvatar.types'
export type { StyledFunctionalAvatarProps } from './styles/FunctionalAvatar.style.types'
